import { Box, BoxProps } from "@mui/material";
import { ReactNode, Ref } from "react";
import {
  ReactZoomPanPinchContentRef,
  ReactZoomPanPinchProps,
  TransformComponent,
  TransformWrapper,
} from "react-zoom-pan-pinch";

interface Props extends ReactZoomPanPinchProps {
  wrapperRef?: Ref<ReactZoomPanPinchContentRef>;
  /** Styles for all blocks that wrap the children. */
  allWrappersSx?: BoxProps["sx"];
  children: ReactNode;
}

export default function ZoomableBlock({
  wrapperRef,
  allWrappersSx,
  children,
  ...otherProps
}: Props) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        "& .react-transform-wrapper": { width: "100%", height: "100%", ...(allWrappersSx as any) },
        "& .react-transform-component": {
          width: "100%",
          height: "100%",
          ...(allWrappersSx as any),
        },
        ...allWrappersSx,
      }}
    >
      <TransformWrapper ref={wrapperRef} {...otherProps}>
        <TransformComponent contentStyle={{ position: "relative", width: "100%", height: "100%" }}>
          {children}
        </TransformComponent>
      </TransformWrapper>
    </Box>
  );
}
